<template>
  <div id="app">
    <div class="introduction-area" v-show="page === 1">
      <section class="section one">
        <div class="item-image">
          <img src="./assets/dbe09b8a5292.png" alt="">
        </div>
        <div class="item-text">
          <h3>01</h3>
          <h4>事故救援</h4>
          <p>
            一键下单
            <br>
            实时与您电话沟通
          </p>
        </div>
      </section>
      <section class="section two">
        <div class="item-text">
          <h3>02</h3>
          <h4>事故维修代步车</h4>
          <p>
            可免费体验3-15天
            <br>
            事故维修代步车
          </p>
        </div>
        <div class="item-image">
          <img src="./assets/72fa56db852e.png" alt="">
        </div>
      </section>
      <section class="section three">
        <div class="item-image">
          <img src="./assets/d8505c88f56e.png" alt="">
        </div>
        <div class="item-text">
          <h3>03</h3>
          <h4>交通补贴</h4>
          <p>
            一键下单
            <br>
            如不使用事故维修代步车 可按理赔金额5%作为交 通补贴
          </p>
        </div>
      </section>
      <button @click="next()">
        立即下单
      </button>
    </div>
    <div class="order-area" v-show="page === 2">
      <div class="order-form-area">
        <div class="map">
          <img :src="staticmap" alt="">
        </div>
        <div class="form-wrapper">
          <div class="form-item">
            <label for="Address">
              事故地址
            </label>
            <input type="text" id="Address" placeholder="请输入您的救援地址" v-model="address">
            <a href="javascript:" class="input-close" v-show="address.length>0" @click="address=''">
              <span class="close-clear">

              </span>
            </a>
          </div>
          <div class="form-item">
            <label for="Phone">
              手机号
            </label>
            <input type="tel" id="Phone" placeholder="请输入您的手机号" v-model="phone" maxlength="11">
            <a href="javascript:" class="send-button" @click="sendMessage" v-show="countdown>=60">
                获取验证码
            </a>
            <a href="javascript:" class="send-button"  v-show="countdown<60">
                {{countdown}}s
            </a>
          </div>
          <div class="form-item">
            <label for="Captcha">
              验证码
            </label>
            <input type="tel" id="Captcha" placeholder="请输入验证码" v-model="captcha" maxlength="6">
          </div>
        </div>
        <div :class="sendData?'submit':'submit disabled'">
          <button @click="saveData">
            确定
          </button>
        </div>
        <span class="agreement" @click="showAgreement=true">
          服务协议
        </span>
      </div>
    </div>
     <div :class="showTooltip?'msg-tooltip show':'msg-tooltip'">
      <div class="content">
        {{tooltipContent}}
      </div>
    </div>

    <div :class="showModal?'msg-modal show':'msg-modal'">
      <div class="content">
        <div class="body">
          {{modalContent}}
        </div>
        <div class="button" @click="showModal=false">
          <img src="" alt="" srcset="">
          <span>好的</span>
        </div>
      </div>
    </div>

    <div :class="showAgreement?'agreement-modal show':'agreement-modal'">
      <div class="content">
        <div class="body">
          <p style="text-align: center;">
              <strong>维修推送客户代步车服务电子协议</strong>
          </p>
          <p>
              <br/>
              <strong>一、委托出租方的权利和义务</strong>
              <br/>
              1、在下述任何一种情况发生时，委托出租方有权随时随地收回所租车辆，已收取的款项在计算所有损失后多退少补：
              <br/>
              （1）承租方利用所租车辆从事违法犯罪活动。
              <br/>
              （2）承租方将所租赁车辆转让、转租、出售、抵押、质押。
              <br/>
              （3）从事其它有损委托出租方车辆合法权益的活动。
              <br/>
              （4）未经出租方书面许可，在车辆租赁期限结束后拖欠还车；
              <br/>
              （5）法律所规定的其它不可从事的活动。在以上情况下给委托出租方造成经济损失的，承租方应作出相应赔偿。
              <br/>
              2、其它的依照法律、法规的规定委托出租方应有的权利。
              <br/>
              3、按合同约定提供技术状况良好各种证照及规费齐全的车辆。
              <br/>
              4、租赁期间对车辆使用情况进行实时监控及对客户信誉实施评价。
          </p>
          <p>
              <br/>
              <strong>二、承租方的权利和义务</strong>
              <br/>
              1、凡在我司合作平台下单事故维修推送的客户在我司协议指定的合作4S店商户
              进行事故车辆维修可享3-15天免费代步车服务或维修期间每天的交通补贴（交通补贴金额为事故修理金额的百分之五）。
          </p>
          <p>
              备注：维修推送客户只可在免费代步车服务和交通补贴中选择一项。
          </p>
          <p>
              申请维修共享代步车必须符合以下条件：
              <br/>
              （1）申请下单人必须为维修车辆车主本人或委托人；
              <br/>
              （2）必须在我司指定的维修共享代步车服务网点进行车辆交接；
              <br/>
              （3）申请维修共享代步车的客户需同意车阵通共享租车合同。
          </p>
          <p>
              2、于租赁合同规定的租赁时段拥有所租赁车辆的使用权。
              <br/>
              3、对租赁车辆承租前已有的损伤不承担赔偿、维修义务。
              <br/>
              4、在租赁合同书签署之日足额交纳抵押金、车辆风险保障金。
              <br/>
              5、自行承担租赁期内所租车辆的燃油费用。
              <br/>
              6、租期内应严格遵守国家各项法律法规，并承担由于违章、违法肇事等行为所产生的全部责任及经济损失。
              <br/>
              7、承租方必须承担由于承租方行为带来的其它经济损失。
              <br/>
              8、协助委托出租方办理车辆保险事故的定损、理赔。
              <br/>
              9、承租方如有车辆续租要求需提前4小时通知委托出租方如想续借车阵通共享代步车，可在租期到期前4小时致电相关客服人员，按正常租金续租。
          </p>
          <p>
              <br/>
              <strong>三、商户的权利与义务</strong>
              <br/>
              1、所有申请维修共享代步车业务需是车阵通指定4S店商户的维修车客户；
              <br/>
              2、维修共享代步车业务客户必须在车阵通指定4S店商户进行车辆维修；
              <br/>
              3、事故维修车辆交车前，4S店商户工作人员必须通知委托出租方经办人，完成交易共享代步车交接后，才能将事故维修车辆归还承租方客户；
              <br/>
              4、如维修服务商户未按以上三条规定执行，所发生的一切风险及损失由服务商户承担。
          </p>
          <p>
              <br/>
              <strong>四、车辆风险保障金条款</strong>
              <br/>
              1、承租方应于租赁合同书签署之日根据委托出租方关于车辆风险保障金的规定一次性足额交付相应车辆风险保障金给委托出租方。
              <br/>
              2、委托出租方将于租赁合同书签署之日，向承租方一次性收取车辆风险保障金。
              <br/>
              3、车辆风险保障金仅含违章罚款保障金。
              <br/>
              4、委托出租方应于租赁合同书期满或合同解除之日起的15个工作日内，依照本同及附件所规定应扣除的费用扣除后，将剩余车辆风险保障金归还给承租方。
              承租方应在接到出租方违章处理通知之日起5个工作日内，完成承租期内的违章处理事宜，
              自第6个工作日起，出租方有权以100元/日的标准收取承租方的违章处理滞纳金，
              该滞纳金首先从承租方预缴付的车辆风险保障金中扣除，车辆风险保障金余额不足之时，承租方应另行缴付该滞纳金，直至完成违章处理事宜为止。
          </p>
          <p>
              <br/>
              <strong>五、保险条款</strong>
              <br/>
              1、委托出租方已就租赁车辆提供相应保险（交通强制保险，第三者责任险，车辆损失险等）。
              <br/>
              2、承租方应在交通事故发生之时起的12个小时内通知委托出租方，
              承租方在24小时内配合委托出租方将保险事故车辆送至委托出租方指定的修理厂，
              承租方必须提供有效的全部保险理赔证明手续。
              承租人在承租车辆期间若发生车辆被盗、
              报废或其它形式的灭失，承租人应负担该租赁车辆灭失之日起至委托出租方获得保险公司赔款时止（最长不超过3个月）的车辆租金及保险免赔部分的经济损失。
              <br/>
              3、由于承租方的原因造成的保险公司拒赔及免赔的所有损失及相关费用（包括但不限于......）由承租人承担。
              <br/>
              4、车辆发生保险事故，如承租方不能取得保险公司理赔必须的有关手续，则由承租方负担全部维修费用及折旧费，并承担保险事件不能赔付的责任。
              <br/>
              5、车辆归还委托出租方时，如有车辆表面损伤且承租方未按保险流程处理，
              则承租方按200元/面支付车辆维修费用给委托出租方，该笔费用在车辆交接单上注明，此费用在风险保障金中扣除。
          </p>
          <p>
              <br/>
              <strong>六、违约责任</strong>
              <br/>
              1、除重大政策性变化或不可抗力外，任何一方违反合同的规定致使合同不能全部履行的，除赔偿相应经济损失外，还应向另一方支付合同及附件未履行部分租赁金额总额30%的违约金。
              <br/>
              2、承租方应按双方签定的还车时间及时交还租赁车辆，
              逾期1小时以内作为缓冲期，不收取租金，逾期1小时以上至12小时以内则按逾期半天租金计算，
              逾期12以上至24小时以内按1天租金计算，每逾期交还24小时以上，除继续计收租金外，需另外交付日租金30%的违约金。
          </p>
          <p>
              <br/>
              <strong>七、合同的变更和解除</strong>
              <br/>
              本合同的变更和解除，必须经租赁双方签署书面协议方能有效。
          </p>
          <p>
              <br/>
              <strong>八、争议的解决</strong>
              <br/>
              有关本合同之一切争议，首先应友好协商解决，如协商解决不成，
              任何一方可向委托出租方公司经营所在地的人民法院诉讼解决，
              诉讼相关费用（包括但不限于诉讼费、调查取证费、担保公司费用、交通费、律师服务费等）由败诉方承担。如客户与商户之间产生纠纷争议，由双方直接协商解决。
          </p>
          <p>
              <br/>
              <strong>九、本合同协议由承租方阅读同意后即生效</strong>
              <br/>
              在承租方预约车阵通共享代步车服务时下订单即视作已详细阅读并同意。
          </p>
          <p>
              <br/>
              <strong>十、维修代步车计费规则（系统自动生成）</strong>
              <br/>
              1、违章保证金1500元
          </p>
          <p>
              违章保证金将在还车后第15个工作日确认无违章后返还
              <br/>
              2、租金
              <br/>
              舒适型外牌/5座：188元/天（例：中华V5）
              <br/>
              舒适型沪牌/5座：228元/天（例：荣威E550）
          </p>
          <p>
              舒适型沪牌/7座：358元/天（例：中华华颂）
              <br/>
              3、公里数
              <br/>
              限定200公里/天（超过24小时按照2天计算），超1公里按1元/公里计费，公里数可按实际使用天数累计计算
              <br/>
              4、油量
              <br/>
              未加油：按1公里/元计费
              <br/>
              已加油：油量表默认为16格，还车时超过出车时初始油量返还25元/格，少于出车时初始油量收取25元/格
              <br/>
              5、超时
              <br/>
              超过预定还车时间每小时按租金1/10计算，超过10小时默认为1天；
              例：3月1日13:00租借舒适型外牌/5座为188/天，预计还车时间为3月2日13:00，实际还车时间为3月2日14:00，则需付超时费18.8元。
              <br/>
              6、提前还车
              <br/>
              租借车阵通专属代步车两天以内（含两天）客户实际还车时间早于预计还车时间，所使用积分不退还，现金按照实际剩余金额退还。
              <br/>
              7、积分使用规则
              <br/>
              车阵通共享代步车中维修代步车租金抵用：积分仅可抵用车辆租金，不得抵用违章押金及油费等其它费用，续租不可使用积分抵用。
          </p>
          <p>
              <br/>
              最终解释权归车阵通所有<em> </em>
          </p>
        </div>
         <div class="close" @click="showAgreement=false"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      page: 1,
      latitude: '121.302073',
      longitude: '31.189997',
      address: '国家会展中心',
      staticmap:
        'https://restapi.amap.com/v3/staticmap?zoom=14&size=818*552&location=121.302073,31.189997&key=b4f5e9a7d375a20a141c18ccee7e4be7',
      phone: '',
      captcha: '',
      countdown: 60,
      showModal: false,
      modalContent: '提交成功！救援小队正在向你赶来',
      showTooltip: false,
      showAgreement: false,
      tooltipContent: '发送成功!',
      sendData: false,
      agreementBody: '',
      isPhone: /^(1[3-9])\d{9}$/,
    };
  },
  methods: {
    saveData() {
      if (this.sendData) {
        axios({
          method: 'post',
          url: 'https://node.chezhentong.com/v2/api//maintain/order',
          data: {
            Customer_Phone: this.phone,
            Longitude: this.longitude,
            Latitude: this.latitude,
            Rescue_Address: this.address,
          },
        })
          .then(({ data }) => {
            if (data.errCode === 0) {
              this.phone = '';
              this.captcha = '';
              this.countdown = 60;
              this.showModal = true;
            }
          });
      } else {
        this.modalContent = '请完善订单信息后再提交!';
      }
    },
    sendMessage() {
      if (this.isPhone.test(this.phone)) {
        axios
          .get(`https://node.chezhentong.com/v2/api/send/msg/${this.phone}`)
          .then(({ data }) => {
            if (data && data.errCode === 0) {
              this.showTooltip = true;
              this.tooltipContent = '验证码发送成功!';
            } else {
              this.showTooltip = true;
              this.tooltipContent = '验证码发送失败,请重试!';
            }
          });
        const timeinterval = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown -= 1;
          } else {
            clearInterval(timeinterval);
            this.countdown = 60;
          }
        }, 1000);
      } else {
        this.showTooltip = true;
        this.tooltipContent = '请输入正确的手机号!';
      }
    },
    getLoation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          this.staticmap = `https://restapi.amap.com/v3/staticmap?zoom=15&size=818*552&scale=2&traffic=1&location=${
            this.longitude
          },${this.latitude}&key=b4f5e9a7d375a20a141c18ccee7e4be7`;
          axios
            .get('https://restapi.amap.com/v3/geocode/regeo', {
              params: {
                key: 'b4f5e9a7d375a20a141c18ccee7e4be7',
                location: `${this.longitude},${this.latitude}`,
                radius: '1000',
              },
            })
            .then(({ data }) => {
              if (data.info === 'OK') {
                this.address = data.regeocode.formatted_address;
              }
            });
        });
      }
    },
    next() {
      this.page = 2;
    },
  },
  watch: {
    page(val) {
      if (val === 2) {
        this.getLoation();
      }
    },
    address(val) {
      if (!val) {
        this.sendData = false;
      } else if (this.phone && this.captcha) {
        this.sendData = true;
      }
    },
    captcha(val) {
      if (!val) {
        this.sendData = false;
      } else if (this.address && this.phone && val.length === 6) {
        axios
          .get(`https://node.chezhentong.com/v2/api/send/msg/check/${val}/${this.phone}`)
          .then(({ data }) => {
            if (data.errCode !== 0) {
              this.sendData = false;
              this.showTooltip = true;
              this.captcha = '';
              this.tooltipContent = '请输入正确的验证码!';
            } else {
              this.sendData = true;
            }
          });
        this.sendData = true;
      }
    },
    phone(val) {
      if (!val) {
        this.sendData = false;
      } else if (this.address && this.captcha) {
        this.sendData = true;
        this.captcha = '';
      }
    },
    showTooltip(val) {
      if (val) {
        setTimeout(() => {
          this.showTooltip = !val;
        }, 2000);
      }
    },
  },
};
</script>

<style lang="less">
*::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

input {
    background: transparent;
    outline: none;
}

.introduction-area {
  position: relative;
  padding-bottom: 1.5rem;
  width: 100vw;
  height: 100vh;
  .section {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    margin: 1.8rem 0.2rem;
    .item-image {
      width: 6rem;
      > img {
        width: 100%;
      }
    }
    .item-text {
      text-align: left;
      font-size: 0.32rem;
      > h3 {
        color: #f9884c;
        font-size: 0.48rem;
        font-weight: 500;
        margin: 0;
      }
      > h4 {
        color: #333333;
        font-size: 0.37rem;
        font-weight: 500;
        margin: 0.1rem 0;
      }
      > p {
        color: #666666;
        display: inline-block;
        width: 3rem;
        margin: 0;
      }
    }
  }
  > button {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    background-color: #f9884c;
    color: #fff;
    text-align: center;
    font-size: 0.48rem;
    line-height: 1.31rem;
    padding: 0;
    margin: 0;
    border: none;
  }
}
.order-area {
  .order-form-area {
    .map {
      height: 6.67rem;
      width: 100vw;
      overflow: hidden;
      img {
        width: 100%;
        animation: 3s scaleMap forwards;
        animation-iteration-count: 1;
        filter: grayscale(30%);
      }
      @keyframes scaleMap {
        0% {
          transform: scale(1);
        }
        100% {
          transform: scale(1.5);
        }
      }
    }
    .form-wrapper {
      border-radius: 4px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.07);
      transform: translate(0, -50%);
      background-color: #fff;
      width: 9.47rem;
      margin: 0 auto;
      overflow: hidden;
      .form-item {
        box-sizing: border-box;
        position: relative;
        padding: 0.3rem;
        width: 9.47rem;
        line-height: 1.09rem;
        text-align: left;
        font-size: 0.373rem;
        &:before {
          content: " ";
          width: 200%;
          height: 0;
          position: absolute;
          top: 0;
          left: 0;
          border-top: 1px solid #f6f3f1;
          transform: scale(0.5);
          transform-origin: 0 0;
          box-sizing: border-box;
        }
        label {
          width: 2rem;
          color: #666666;
          display: inline-block;
        }
        input {
          box-sizing: border-box;
          color: #333;
          border: none;
          width: 100%;
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          font-size: 0.373rem;
          padding: 0.3rem 1rem 0.3rem 2.2rem;
          line-height: 1.09rem;
          margin-right: 1rem;
          background-color: rgba(0, 0, 0, 0);
        }
        input::placeholder {
          color: #999;
        }
        .input-close {
          display: block;
          position: absolute;
          top: 0;
          width: 2rem;
          right: 0px;
          height: 100%;
          text-align: center;

          .close-clear {
            display: inline-block;
            position: relative;
            width: 0.48rem;
            height: 0.48rem;
            background-color: #666666;
            border: 1px solid #666666;
            border-radius: 100%;
            margin: 50% auto 0;
            transform: translate(0, -100%);
            &:before,
            &:after {
              content: "";
              position: absolute;
              height: 2px;
              width: 60%;
              top: 50%;
              left: 20%;
              margin-top: -1px;
              background: #fff;
            }
            &:before {
              transform: rotate(-45deg);
            }
            &:after {
              transform: rotate(45deg);
            }
          }
        }
        .send-button {
          text-decoration: none;
          color: #f9884c;
          position: absolute;
          right: 0.5rem;
        }
      }
    }
    .submit {
      text-align: center;
      button {
        width: 8.4rem;
        text-align: center;
        line-height: 1.307rem;
        border-radius: 4px;
        margin: 1.3rem auto 2.7rem;
        color: #fff;
        background-color: #f9884c;
        border: 0;
        padding: 0;
        font-size: 0.48rem;
      }
    }
    .submit.disabled {
      button {
        background-color: rgba(249, 136, 76, 0.6);
      }
    }
    .agreement {
      display: block;
      color: #999;
      font-size: 0.32rem;
      text-align: center;
      width: 100vw;
      text-decoration: none;
    }
  }
}
.msg-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 50vh;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 0;
  transform: translate3d(0px, -100%, 0px);
  .content {
    position: relative;
    overflow: hidden;
    height: 4.43rem;
    width: 8rem;
    margin: 0 auto;
    transform: translate(0, -100%);
    font-size: 0.373rem;
    text-align: center;
    border-radius: 0.1rem;
    background-color: #fff;
    box-shadow: 0 0.4rem 0.8rem 0 RGBA(0, 0, 0, 0.2);
    opacity: 0;
    transition: all 500ms cubic-bezier(0.4, 0, 0, 1.5);
    .body {
      padding: 1.2rem 0;
    }
    .button {
      font-size: 0.48rem;
      color: #fff;
      background-color: #f9884c;
      line-height: 1.6rem;
      height: 1.6rem;
      border-radius: 4rem 4rem 0 0 ~"/" 2rem 2rem 0 0;
    }
  }
}
.msg-tooltip {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 50vh;
  background-color: rgba(255, 255, 255, 0);
  opacity: 0;
  transform: translate3d(0px, -100%, 0px);
  text-align: center;
  .content {
    position: relative;
    display: inline-block;
    padding: 0 0.5rem;
    line-height: 1rem;
    margin: 0 auto;
    transform: translate(-300%, 0);
    font-size: 0.373rem;
    text-align: center;
    border-radius: 0.1rem;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    opacity: 0;
    transition: all 500ms cubic-bezier(0.4, 0, 0, 1.5);
  }
}
.agreement-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 12px;
  background-color: rgba(0, 0, 0, 0.6);
  transform: translate3d(0px, -200%, 0px);
  visibility: hidden;
  .content {
    position: relative;
    .body {
      position: relative;
      overflow: hidden;
      height: 11rem;
      width: 7rem;
      margin: 1rem auto;
      padding: 2em;
      border-radius: 0.1rem;
      overflow-y: auto;
      background-color: #fff;
      transform: translateY(20%);
      transition: all 300ms 0ms;
    }
  }
  .close {
    text-align: center;
    position: relative;
    width: 36px;
    height: 36px;
    border: 1px solid #fff;
    border-radius: 100%;
    margin: 1rem auto;
    &:before,
    &:after {
      content: "";
      position: absolute;
      height: 2px;
      width: 60%;
      top: 50%;
      left: 20%;
      margin-top: -1px;
      background: #fff;
    }
    &:before {
      transform: rotate(-45deg);
    }
    &:after {
      transform: rotate(45deg);
    }
  }
}

.agreement-modal.show .content .body {
  opacity: 1;
  transform: translate(0, 0%);
}
.show {
  display: block;
  visibility: visible;
  opacity: 1;
  transform: translate3d(0px, 0px, 0px);
}
.msg-modal.show .content {
  opacity: 1;
  transform: translate(0, -50%);
}
.msg-tooltip.show .content {
  opacity: 1;
  transform: translate(0, 0);
}
</style>




// WEBPACK FOOTER //
// src/App.vue